import { useAuth } from 'react-oidc-context'
import { Navigate, Route, Routes } from 'react-router-dom'
import Dashboard from '../pages/Dashboard'
import NotFoundPage from '../pages/404'
import Comparison from '../pages/Comparison'
import PlanAndBillingsView from '../pages/PlansAndBilling'
import PropertyDetailView from '../pages/PropertyDetail'
import OnboardingPage from '../pages/Onboarding'
import SubscriptionSuccessPage from '../pages/SubscriptionSuccess'

// ProtectedRoute component
// Ensures that only authenticated users can access protected routes.
// If the user is not authenticated, they are redirected to the login page.
const ProtectedRoute = ({ children }) => {
  const auth = useAuth()

  if (!auth.isAuthenticated) {
    localStorage.removeItem('access_token', auth.user?.access_token)
    auth.signinRedirect({ redirect_uri: window.location.href })
    return null // Redirect to login if not authenticated
  }

  return children // Render children (protected content) if authenticated
}

// AppRoutes component
// Defines all the routes in the application, including protected and public routes.
// Uses ProtectedRoute for authenticated pages like the dashboard and CompareProperty.
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path='/dashboard'
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path='/comparison'
        element={
          <ProtectedRoute>
            <Comparison />
          </ProtectedRoute>
        }
      />
      <Route
        path='/properties'
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path='/plans-and-billing'
        element={
          <ProtectedRoute>
            <PlanAndBillingsView />
          </ProtectedRoute>
        }
      />

      <Route
        path='/subscription-success'
        element={
          <ProtectedRoute>
            <SubscriptionSuccessPage />
          </ProtectedRoute>
        }
      />

      <Route
        path='/'
        element={
          <ProtectedRoute>
            <Navigate to='/properties' />
          </ProtectedRoute>
        }
      />
      <Route
        path='/properties/:id'
        element={
          <ProtectedRoute>
            <PropertyDetailView />
          </ProtectedRoute>
        }
      />

      {/* Public route — no auth required */}
      <Route path='/onboarding' element={<OnboardingPage />} />

      {/* Wildcard route for undefined pages */}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRoutes
